<template>
  <div id="target-analyse" style="overflow: hidden">
    <div class="targetAnalyse-data">
      <div class="targetAnalyse-data-head">
        <div class="targetAnalyse-head-title">
          <span class="targetAnalyse-data-head-container">靶标图片分析</span>
        </div>

        <div class="targetAnalyse-head-select">
          <div class="targetAnalyse-select-device">
            <el-select @change="targetDeviceChange($event)" v-model="defaultTargetDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in targetDeviceList"></el-option>
            </el-select>
          </div>

          <div class="targetAnalyse-select-time">
            <el-date-picker @change="targetSelectTime" v-model="defaultTargetTime" unlink-panels type="datetimerange" :picker-options="targetPickerOptions" align="right"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="targetAnalyse-select-btn">
            <el-button type="primary" @click="targetQueryData()">查询</el-button>
          </div>
        </div>

        <div class="targetAnalyse-head-operation">
          <div class="targetAnalyse-operation-container">
            <el-button type="warning" @click="targetState()">设备信息</el-button>
            <el-button type="danger" @click="targetOperation()">设备操作</el-button>
          </div>
        </div>
      </div>

      <div class="targetAnalyse-data-content" style="overflow: auto;">
        <div v-for="(row, index) in sliceList(targetPicLists.slice((targetCurrentPage-1)*4,targetCurrentPage*4), 2)" :key="index" class="targetAnalyse-data-main">
          <div class="targetAnalyse-content-container">
            <div v-for="(item ,i) in row" class="targetAnalyse-content-item">
              <div class="targetAnalyse-item-img">
                <img :src= "item.targetUrl" @error="e => {e.target.src = item.imageUrl}" class="targetAnalyse-item-imgValue" referrerpolicy="no-referrer"/>
              </div>
              <div class="targetAnalyse-item-main">
                <div class="targetAnalyse-item-name">
                  <span class="targetAnalyse-item-value">设备ID：{{item.deviceId}}</span>
                </div>
                <div class="targetAnalyse-item-name">
                  <span class="targetAnalyse-item-value">图像ID：{{item.imgId}}</span>
                </div>
                <div class="targetAnalyse-item-name">
                  <span class="targetAnalyse-item-value">创建时间：{{item.createTime}}</span>
                </div>
                <div class="targetAnalyse-item-result">
                  <span>分析结果：<br/>&#12288{{item.analyseData}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination @current-change="targetCurrentChange" :current-page="targetCurrentPage" class="targetAnalyse-data-bottom"
                       :page-size="4" layout="total, prev, pager, next, jumper" :total="targetPicLists.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'TargetAnalyseData',
    components: {},
    computed: {
      sliceList() {
        return function (data, count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i/count);
              if(arrTemp.length <= index) {
                arrTemp.push([]);
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      }
    },
    data() {
      return {
        targetDeviceList:[],
        defaultTargetDevice: '',
        defaultTargetTime: [ moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
        targetPickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        beginTime: '',
        endTime: '',
        targetPicLists: [],
        targetCurrentPage: 1,
      }
    },

    mounted() {
      //获取用户等级
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      if(authority != 'TENANT_ADMIN') {
        this.getTargetDevice(customerId); //获取靶标设备
      }
      this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss");//默认开始时间
      this.endTime = moment().format("YYYY-MM-DD HH:mm:ss")//默认结束时间
    },

    methods: {
      /**
       * 获取靶标设备
       * @param customerId
       */
      getTargetDevice(customerId) {
        let that = this;
        this.$MeteSoilCommon.getCustomerData(customerId, function (response) {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key.toString().indexOf('target') > -1) {
              let jsonTarget = JSON.parse(response.data[i].value);
              that.targetDeviceList.push({"deviceAddr": jsonTarget.name, "deviceName": jsonTarget.name})
            }
          }
          if(that.targetDeviceList.length > 0) {//靶标设备存在
            that.defaultTargetDevice = that.targetDeviceList[0].deviceAddr; //默认靶标设备
            that.targetDeviceData();//查询靶标历史数据
          }
        })
      },

      /**
       * 切换靶标设备
       * @param event
       */
      targetDeviceChange(event) {
        this.defaultTargetDevice = event;
        this.targetPicLists = [];
      },

      /**
       * 获取选中的日期
       * @param val
       */
      targetSelectTime(val) {
        if(val == null) { //清空日期
          this.defaultTargetTime = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]; //默认时间
          this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //默认开始时间
          this.endTime = moment().format("YYYY-MM-DD HH:mm:ss");//默认结束时间
        } else {//非清空数据
          this.beginTime = moment(new Date(val[0]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //开始时间
          this.endTime = moment(new Date(val[1]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //结束时间
        }
      },

      /**
       * 查询按钮
       */
      targetQueryData() {
        if(this.defaultTargetDevice != '') {//默认靶标数据存在
          this.targetDeviceData();
        }
      },

      /**
       * 查询靶标历史数据
       */
      targetDeviceData() {
        this.targetPicLists = [];
        this.targetCurrentPage = 1;
        let that = this;
        this.$SporePestCommon.getDeviceImg(this.defaultTargetDevice, this.beginTime, this.endTime, function (response) {
          if(response.length > 0) {
            for(let i = 0; i < response.length; i++) {
              let json = {};
              json.deviceId = response[i].device_id;
              json.imgId = response[i].img_id;
              json.createTime = response[i].create_time.substring(0, 10) + " " + response[i].create_time.substring(11, 19);
              json.imageUrl = response[i].img_url;
              json.targetUrl = response[i].target_url;
              json.analyseData = '';
              that.targetPicLists.push(json);
              that.targetImgData(i, response[i].img_id); //根据imgId获取图片分析后图片
            }
          } else {
            that.$message({
              showClose: true,
              type: 'warning',
              message: '所选时间段内未查询出数据'
            })
          }
        })
      },

      /**
       * 根据imgId获取图片分析后图片
       * @param i
       * @param imgId
       */
      targetImgData(i, imgId) {
        // let arr = [
        //   {
        //     "cato": "美国白蛾",
        //     "box": "[0.8063, 0.6149, 0.83258, 0.66633]",
        //     "cnt4mask": "[[[0.82294, 0.61899]], [[0.8155, 0.62893]], [[0.8098, 0.63828]], [[0.8063, 0.6523]], [[0.8155, 0.65405]], [[0.82251, 0.66633]], [[0.82776, 0.64821]], [[0.83215, 0.6336]], [[0.83258, 0.6225]], [[0.82733, 0.6149]]]",
        //     "annotation_type": "manual",
        //     "img_id": "YBQ00000015_20200903180431000_01.jpg"
        //   },
        //   {
        //     "cato": "美国飞蛾",
        //     "box": "[0.8063, 0.6149, 0.83258, 0.66633]",
        //     "cnt4mask": "[[[0.82294, 0.61899]], [[0.8155, 0.62893]], [[0.8098, 0.63828]], [[0.8063, 0.6523]], [[0.8155, 0.65405]], [[0.82251, 0.66633]], [[0.82776, 0.64821]], [[0.83215, 0.6336]], [[0.83258, 0.6225]], [[0.82733, 0.6149]]]",
        //     "annotation_type": "manual",
        //     "img_id": "YBQ00000015_20200903180431000_01.jpg"
        //   },
        //   {
        //     "cato": "美国白蛾",
        //     "box": "[0.8063, 0.6149, 0.83258, 0.66633]",
        //     "cnt4mask": "[[[0.82294, 0.61899]], [[0.8155, 0.62893]], [[0.8098, 0.63828]], [[0.8063, 0.6523]], [[0.8155, 0.65405]], [[0.82251, 0.66633]], [[0.82776, 0.64821]], [[0.83215, 0.6336]], [[0.83258, 0.6225]], [[0.82733, 0.6149]]]",
        //     "annotation_type": "manual",
        //     "img_id": "YBQ00000015_20200903180431000_01.jpg"
        //   }
        // ];

        let obj = {};
        let that = this;

        this.$SporePestCommon.getImgData(imgId, function (response) {
          if(response.length == 0) {//当前图片未分析或者分析为空
            that.targetPicLists[i].analyseData = '未分析';
          } else { //图片分析
            response.forEach(v => obj[v.cato] = obj[v.cato] === undefined ? 1 : obj[v.cato] + 1);
            let str = "";
            for(let o in obj) {
              str += o + ":" + obj[o] + "；";
            }
            that.targetPicLists[i].analyseData = str;
          }
        })
      },

      /**
       *  切换页数
       * @param currentPage
       */
      targetCurrentChange(currentPage) {
        this.targetCurrentPage = currentPage;
      },

      /**
       *  远程操作接口
       */
      targetOperation() {
        this.$operate({
          deviceAddr: this.defaultTargetDevice,
          click: () => {
            console.log(``)
          },
        })
      },

      /**
       * 获取靶标设备状态
       */
      targetState() {
        this.$stateInfo({
          deviceAddr: this.defaultTargetDevice,
          deviceType: '靶标',
          click: () => {
            console.log(``)
          }
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../less/TargetAnalyseData";
</style>

<style>
  .targetAnalyse-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/TargetAnalyseData.vue